import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=fd19811a"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd19811a')) {
      api.createRecord('fd19811a', component.options)
    } else {
      api.reload('fd19811a', component.options)
    }
    module.hot.accept("./EventCategory.vue?vue&type=template&id=fd19811a", function () {
      api.rerender('fd19811a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/EventCategory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EventCategory.vue
// module id = 367
// module chunks = 0